import type { DataRouter } from "react-router";
import { RouterProvider } from "react-router/dom";

export function AppRouterProvider({ router }: { router: DataRouter }) {
  // No transitions (#1083): Apollo's useQuery reobserves during render, so each interrupted
  // navigation re-sent its network-only query, and the answer interrupted the next attempt.
  // flushSync is no way out: after route loaders the router commits without it.
  return <RouterProvider router={router} useTransitions={false} />;
}
